import { useAuthStore } from '@/auth/authStore';
import { SERVER_URL, COMMON_HEADERS } from '@/config/serverUrl';

export type Rarity = 'common' | 'rare' | 'epic' | 'legendary';

export interface HoldSkinEntry {
  id: string;
  name: string;
  description: string | null;
  rarity: Rarity;
  priceCoins: number;
  priceGems: number;
  imageUrl: string | null;
  owned: boolean;
  equipped: boolean;
  /** null = never trialed; 0 = trialed & expired; >0 = active trial uses left. */
  trialUsesLeft?: number | null;
}

export interface HoldSkinList {
  coins: number;
  gems: number;
  equippedId: string | null;
  equippedUrl: string | null;
  defaultUrls: string[];
  items: HoldSkinEntry[];
}

const BASE = SERVER_URL;

async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = useAuthStore.getState().token;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...COMMON_HEADERS,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body == null ? undefined : JSON.stringify(body),
    credentials: 'include',
  });
  if (!res.ok) {
    let detail = '';
    try { const j = await res.json(); detail = j?.message ?? j?.error ?? ''; } catch { /* */ }
    throw new Error(detail || `HoldSkins API ${res.status}`);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export const holdSkinsApi = {
  list: () => req<HoldSkinList>('GET', '/holdskins/'),
  buy: (id: string, currency: 'coins' | 'gems') =>
    req<{ coins: number; gems: number }>('POST', `/holdskins/${id}/buy`, { currency }),
  equip: (id: string) => req<{ equippedId: string }>('POST', `/holdskins/${id}/equip`),
  unequip: () => req<{ equippedId: null }>('POST', '/holdskins/unequip'),
};
